"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeviceManufacturer = void 0;
const DeviceType = Object.freeze({
  BRIGHTSIGN: 'brightsign'
});
const DeviceManufacturer = exports.DeviceManufacturer = Object.freeze({
  [DeviceType.BRIGHTSIGN]: 'BrightSign'
});
var _default = exports.default = DeviceType;